let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bDP5R")).then(() => parcelRequire('9kLXx'));